module.exports = __webpack_public_path__ + "img/Advantage_icon04.ab8a534a.png";